import { Box, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { TitleDivider } from '../../../components/titleDivider';
import { BorrowerFormStore } from '../../../stores/borrowers/borrowerFormStore';
import {
  Assets,
  BorrowerAddress,
  BorrowerEmail,
  CitizenshipStatus,
  CollectCreditReportWithMessage,
  CreditPull,
  DateOfBirth,
  FicoScore,
  FirstNameAutocompleteField,
  IsRealEstateBrokerAgent,
  IsTheBorrowerAGeneralContractor,
  LastName,
  Liabilities,
  NetWorth,
  NumberOfVerifiedInvestmentProperties,
  OwnershipPercentage,
  PersonalGuarantor,
  PhoneNumber,
  SocialSecurityNumber,
  Xactus360Upload,
} from '../../borrowerInformation/components/borrowerInformationFields';
import { FormHeader } from '../../common/formHeader';
import { PermIdentityOutlined } from '@material-ui/icons';
import { useEffect } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CreditStatus, CreditPull as CreditPullEnum } from '../../../utils/constants';
import { LoanSubType } from '@roc/feature-utils';

export const PrefligthBorrowerForm = observer(
  ({
    store,
    showPersonalGuarantorField,
    loanSubtype
  }: {
    store: BorrowerFormStore;
    showPersonalGuarantorField: boolean;
    loanSubtype: LoanSubType;
  }) => {
    const fundedBorrower = store.form.fields.projectsCompleted.value;

    const firstName = store.form.fields.firstName.value;
    const { globalStore } = useStore();

    // useEffect(() => {
    //   if (globalStore?.lenderInfo?.showOnlyCafOption) {
    //     store.onFieldChange('creditPull', CreditPullEnum.BORROWER_AUTHORIZATION_FORM);
    //   }
    // }, []);

    // useEffect(() => {
    //   if (firstName) {
    //     store.findBorrowersByNameDebounced(firstName);
    //   }
    // }, [firstName]);

    useEffect(() => {
      if (globalStore.isBrokerPortal || store.creditStatus === CreditStatus.CREDIT_AND_BACKGROUND_OK || store.creditStatus === CreditStatus.CREDIT_AND_BACKGROUND_CHECK_SENT) {
        store.onFieldChange('creditBackgroundCheck', false);
      }
    }, [store.creditStatus]);

    return (
      <Grid container spacing={2}>
        <FormHeader icon={PermIdentityOutlined} title="Borrower" />
        <Grid item xs={12}>
          <Box px={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <FirstNameAutocompleteField store={store} disabled={true} required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LastName store={store} disabled={true} />
              </Grid>
              <Grid item xs={12}>
                <BorrowerEmail store={store} disabled={true} required />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <FicoScore store={store} disabled={!Boolean(store?.selectedRecord['ficoScore']) ? false : fundedBorrower} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberOfVerifiedInvestmentProperties store={store} disabled={!Boolean(store?.selectedRecord['numberOfVerifiedInvestmentProperties']) ? false : fundedBorrower} />
              </Grid> */}
            </Grid>
          </Box>
        </Grid>
        {/* {(store.creditStatus === CreditStatus.CREDIT_AND_BACKGROUND_OK || store.creditStatus === CreditStatus.CREDIT_AND_BACKGROUND_CHECK_SENT || showPersonalGuarantorField) && !globalStore?.lenderInfo?.showOnlyCafOption &&
          <>
            <Grid item xs={12}>
              <Box px={2}>
                <TitleDivider title="Additional Options" />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box px={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CreditPull store={store} creditStatus={store.creditStatus} />
                  </Grid>
                  {showPersonalGuarantorField && (
                    <Grid item xs={12}>
                      <PersonalGuarantor store={store} />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>
          </>
        }
        <Grid item xs={12}>
          <Box px={2}>
            <TitleDivider title="Ownership" />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box px={12}>
            <OwnershipPercentage store={store} />
          </Box>
        </Grid> */}
        <Grid item xs={12}>
          <Box px={2}>
            <TitleDivider title="Additional Options" />
          </Box>
        </Grid>
        {!globalStore.isBrokerPortal && (
          <Grid item xs={12}>
            <Box px={12}>
              <CollectCreditReportWithMessage store={store} label='Do you want to send the credit authorization?' creditStatus={store.creditStatus} />
            </Box>
          </Grid>
        )}
      </Grid>
    );
  }
);
